import SimpleBar from "simplebar-react";
import classNames from "classnames";
import { useDispatch } from "react-redux";

import LockedPostsButtons from "../LockedPostsButtons";
import LazyImage from "../LazyImage";
import { useService } from "@/base/hooks/useService";
import { followCreator } from "@redux/creatorProfile/actions";
import { localstorageKeys } from "@const/store";
import { StorageService } from "@services/StorageService";

import styles from "./index.module.scss";
import { toggleSignInModal } from "@redux/signIn/actions";
import { getCurrentSrc } from "@helpers/posts";
import { ReactComponent as IconAudioPlaceholder } from "../../assets/ic-post-audio-placeholder.svg";
import FilesCounters from "../FilesCounters";
import routes from "../../const/routes";

const ViewPostModalLocked = ({
  id,
  title,
  previewImage,
  authorId,
  accessType,
  username,
  modalView,
  uniqueKey,
  accessToken,
  withArrows,
  videosCount,
  imagesCount,
  audiosCount,
}) => {
  const storageService = useService(StorageService);

  const dispatch = useDispatch();

  const toggleFollow = () => {
    storageService.set(
      localstorageKeys.destination,
      `${routes.CREATOR_PROFILE()}${username}`,
    );
    if (accessToken) {
      dispatch(
        followCreator({
          username,
          id: authorId,
          shouldFetchPosts: true,
          shouldFetchProfile: true,
          type: "data",
          postId: id,
        }),
      );
      return;
    }
    dispatch(toggleSignInModal(true));
  };

  return (
    <div className="h-100">
      <SimpleBar
        className={classNames(
          "position-relative post-detail-scroll text-post",
          styles.container,
        )}
      >
        <FilesCounters
          images={imagesCount}
          audios={audiosCount}
          videos={videosCount}
          containerStyles="position-absolute post-chip"
          showTextIcon
        />

        <div className="my-auto w-100 h-100">
          <div className={styles.description}>
            <LazyImage
              showBackdrop
              src={getCurrentSrc(previewImage)}
              placeholderImage={IconAudioPlaceholder}
            />
          </div>
          <LockedPostsButtons
            id={id}
            canBePayed
            uniqueKey={uniqueKey}
            title={title}
            username={username}
            accessType={accessType}
            modalView={modalView}
            toggleFollow={toggleFollow}
            accessToken={accessToken}
            isInSubscription={withArrows}
          />
        </div>
      </SimpleBar>
    </div>
  );
};

export default ViewPostModalLocked;
